import React from "react";
import PropTypes from "prop-types";
import AddonButton from "components/Design/Button/AddonButton";
import Icon from "components/CommonIcon/Icon";
import cx from "classnames";
import ConditionalLink from "components/ConditionalLink";

const ButtonFullWidthWithIcon = ({
  label,
  onClick,
  iconName,
  iconClassName,
  handleIconClick,
  buttonLink,
  iconLink,
}) => {
  return (
    <div className="grid grid-cols-6 p-8 shadow-button-with-icon bg-white">
      {iconName && (
        <ConditionalLink
          link={iconLink}
          className="col-span-1 border border-solid border-gray-light mr-8 flex justify-center items-center rounded-sm"
          onClick={handleIconClick}>
          <span className={`${iconClassName}`}>
            <Icon
              name={iconName}
              color="text-green-wa-dark"
              fontSize="text-42"
            />
          </span>
        </ConditionalLink>
      )}
      <div
        className={cx({
          "col-start-2 col-span-8": iconName,
          "col-span-full": !iconName,
        })}>
        {buttonLink ? (
          <ConditionalLink link={buttonLink}>
            <AddonButton label={label} onClick={onClick} fullRounded />
          </ConditionalLink>
        ) : (
          <AddonButton label={label} onClick={onClick} fullRounded />
        )}
      </div>
    </div>
  );
};

ButtonFullWidthWithIcon.defautlProps = {
  iconClassName: "",
  handleIconClick: () => {},
};

ButtonFullWidthWithIcon.propTypes = {
  iconName: PropTypes.string,
  label: PropTypes.string,
  onClick: PropTypes.func,
  iconClassName: PropTypes.string,
  handleIconClick: PropTypes.func,
  buttonLink: PropTypes.object,
};

export default ButtonFullWidthWithIcon;
